module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h1', [_vm._v("\n    Favorecido:\n    "), _c('strong', [_vm._v(_vm._s(_vm.favored.company))])]), _vm._v(" "), _c('div', {
    staticClass: "favored-mob"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.favored.cnpj)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.favored.company))]), _vm._v(" "), _c('p', [_vm._v("\n      Plano:\n      "), _c('strong', [_vm._v(_vm._s(_vm.favored.plan))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "bold"
  }, [_vm._v("Qual o valor da transferência?")]), _vm._v(" "), (_vm.balance) ? _c('p', {
    staticClass: "balance-mob"
  }, [_vm._v("\n    Saldo disponível para transferência\n    "), _c('strong', [_vm._v(_vm._s(_vm._f("cents")(_vm.balance)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "value-box"
  }, [_c('input', {
    staticClass: "form-control input-transfer-value",
    attrs: {
      "type": "text",
      "name": "input-transfer-value",
      "placeholder": "0,00",
      "autofocus": "autofocus"
    },
    domProps: {
      "value": _vm.getValue
    },
    on: {
      "input": function($event) {
        return _vm.setValue($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.currentValue && !_vm.checkTransferValue) ? _c('div', {
    staticClass: "values"
  }, [_c('div', [_c('p', [_vm._v("Taxa (2%)")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.currentValue * 0.02)))])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "bold-600"
  }, [_vm._v("Total")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.currentValue * 1.02)))])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ico-box"
  }, [_c('img', {
    attrs: {
      "src": "static/CarteiraEnvia.svg",
      "alt": "",
      "width": "90"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/Transferencia_verde.png",
      "alt": "",
      "width": "90"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/CarteiraEnvia.svg",
      "alt": "",
      "width": "90"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-b3abd4c8!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/shipper/transfer-shipper-value.vue
// module id = 2201
// module chunks = 1